export default "__VITE_ASSET__dd0b7013__"